import { supabase } from "@/lib/supabase/supabaseClient"
// import { deleteQuestionsFromSurveyBankQuestionBankProps } from "."

export const deleteSelectedQuestionsFromSurveyBankQuestionBank = async (ids: string[]) => await supabase.from('survey_bank_question_bank').delete().in('id', ids)